import {InjectionToken} from '@angular/core';

export interface HttpServerServiceInterface {
    addPostHandler(key: string, handler: (body: any) => Promise<any>): void;
}

export const HTTP_SERVER_SERVICE_TOKEN = new InjectionToken<HttpServerServiceInterface>('http-server-service');
